import axios from "axios";
import { NewsEventModel } from "../entities/NewsEventModel";

const NEWS_TOP = `${process.env.REACT_APP_API_URL}news-top`;
const NEWS_ALL = `${process.env.REACT_APP_API_URL}news-list-all`;
const NEWS_ANOTHER = `${process.env.REACT_APP_API_URL}news-another`;

export const fetchNewsTop = async (): Promise<NewsEventModel[]> => {
    try {
        const response = await axios.get(NEWS_TOP);
        const data = response.data.data; // Access the nested 'data' array.
        
        // Map the response to News Event instances.
        return data.map((item: any) => new NewsEventModel(item.id, item.path, item.path_app, item.news_title, item.news_content, item.news_image_caption, item.news_date_post));
    } catch (error) {
        console.error('Error fetching News:', error);
        throw new Error('Failed to fetch News data: ' + (error as Error).message);
    }
}

export const fetchNewsAll = async (): Promise<NewsEventModel[]> => {
    try {
        const response = await axios.get(NEWS_ALL);
        const data = response.data.data; // Access the nested 'data' array.
        
        // Map the response to News Event instances.
        return data.map((item: any) => new NewsEventModel(item.id, item.path, item.path_app, item.news_title, item.news_content, item.news_image_caption, item.news_date_post));
    } catch (error) {
        console.error('Error fetching News:', error);
        throw new Error('Failed to fetch News data: ' + (error as Error).message);
    }
}

export const fetchNewsAnother = async (): Promise<NewsEventModel[]> => {
    try {
        const response = await axios.get(NEWS_ANOTHER);
        const data = response.data.data; // Access the nested 'data' array.
        
        // Map the response to News Event instances.
        return data.map((item: any) => new NewsEventModel(item.id, item.path, item.path_app, item.news_title, item.news_content, item.news_image_caption, item.news_date_post));
    } catch (error) {
        console.error('Error fetching News:', error);
        throw new Error('Failed to fetch News data: ' + (error as Error).message);
    }
}